import { render } from "./News.vue?vue&type=template&id=174f2bc8&bindings={}"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script